import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import {
	Component,
	computed,
	effect,
	signal,
	Signal,
	ViewEncapsulation,
	WritableSignal
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { Store } from '@ngrx/store';
import { Media } from 'app/core/media';
import { NavigationItem } from 'app/core/navigation/navigation.types';
import { GeneratedFilesComponent } from 'app/layout/common/generated-files/generated-files.component';
import { ProfileComponent } from 'app/layout/common/user/profile.component';
import { UserNotificationsComponent } from 'app/layout/common/user-notifications/user-notifications.component';
import { NavigationComponent } from 'app/layout/layouts/classic/navigation/navigation.component';
import { IAccountState } from 'app/store/account/account.state';
import { selectNavigation } from 'app/store/auth-proxy/auth-proxy.selectors';
import { Observable } from 'rxjs';

@Component({
	selector:      'app-classic-layout',
	templateUrl:   './classic.component.html',
	encapsulation: ViewEncapsulation.None,
	imports:       [
		FuseLoadingBarComponent,
		MatButtonModule,
		MatIconModule,
		ProfileComponent,
		NgIf,
		NgClass,
		RouterOutlet,
		AsyncPipe,
		NavigationComponent,
		GeneratedFilesComponent,
		UserNotificationsComponent
	],
	animations: fuseAnimations
})
export class ClassicLayoutComponent {
	public navigationItems: Observable<NavigationItem[]>;

	protected isScreenSmall: Signal<boolean>;
	protected opened:        WritableSignal<boolean>;

	constructor(
		private readonly media: Media,
		private readonly store: Store<IAccountState>
	) {
		this.navigationItems = this.store.select(selectNavigation);
		this.isScreenSmall = computed(
			() => !this.media.match('(min-width: 960px)')()
		);
		this.opened = signal(!this.isScreenSmall());

		effect(() => this.opened.set(!this.isScreenSmall()));
	}

	protected toggleNavigation(): void {
		this.opened.update(value => !value);
	}

	protected closeNavigation(): void {
		this.opened.set(false);
	}
}
